import React, { forwardRef } from "react";
import ComponentToPrint from "./CreatePDF.js";

const MultiPagePrintWrapper = forwardRef(({ selectedSearchValues, selectedEmployeeTemplateData, routes }, ref) => {
  const pairedEmployees = [];
  for (let i = 0; i < selectedEmployeeTemplateData.length; i += 2) {
    pairedEmployees.push({
      first: selectedEmployeeTemplateData[i],
      second: selectedEmployeeTemplateData[i + 1] || null
    });
  }

  return (
    <div ref={ref}>
      {pairedEmployees.map((pair, idx) => (
        <div
          key={idx}
          className="print-page"
          style={{
            width: "8.5in",
            height: "11in",
            position: "relative",
            pageBreakAfter: "always",
            breakAfter: "page",
            overflow: "hidden",
          }}
        >
          <ComponentToPrint
            selectedSearchValues={selectedSearchValues}
            paySlipData={pair.first}
            paySlipData2={pair.second}
            routes={routes}
          />
        </div>
      ))}
    </div>
  );
});

export default MultiPagePrintWrapper;